export const dividendPaymentLabels = { unpaid: 'Unpaid', paid: 'Paid' };
export interface DividendStatusSource {
  paymentDate: Date | string | null;
  legacyId?: number | null;
  sourceKey?: string | null;
}
/** Provenance and receipt confirmation are independent; expected dates never imply payment. */
export function dividendStatus(row: DividendStatusSource, retainedAtImport = false) {
  return { imported: retainedAtImport || row.legacyId != null || Boolean(row.sourceKey?.startsWith('nocodb:')),
    paymentStatus: row.paymentDate ? 'paid' as const : 'unpaid' as const };
}
